import { $, aviso, el, esc, fecha, limpiar, noContesto, num, pedir, pedirTodo, puede, rpc, sb, ordenarPor } from './nucleo';
import { irACuentaDe } from './proveedores';
import { cargarCatalogos } from './catalogo';

//  Al dar de alta o cambiar un proveedor, los `<select>` que lo ofrecen
//  (Recepción y armar una orden) se vuelven a leer. El de Compras lo vuelve a
//  leer `cargarCompras`, que se registra acá para no importarse en círculo.
let AL_CAMBIAR: (() => void) | null = null;
export const alCambiarProveedores = (f: () => void) => { AL_CAMBIAR = f; };

//  LA FICHA DEL PROVEEDOR (D223, migración 0103). En Compras, la tarjeta
//  «Proveedores» lista todos (activos e inactivos) y el nombre abre la
//  ficha: sus datos (los cambia quien tiene `compra.editar_proveedor`, por
//  `guardar_proveedor`), sus órdenes de compra, sus remitos y su cuenta (el
//  saldo, sólo para quien tiene `proveedor.ver_cuenta`). Cada parte se pide
//  sólo con su permiso: el RLS contesta vacío sin error (regla 5), y un vacío
//  no se dice «no tiene».

let PROVS: any[] = [];
let ERROR_PROVS = '';
let LEIDA = false;
let ABIERTO: number | null = null;   //  el proveedor de la ficha; null: alta
let TURNO = 0;                       //  una lectura vieja no pinta otra ficha
const TOPE = 200;

const editaProv = () => puede('compra', 'editar_proveedor');

export async function cargarProveedoresFicha(){
  $('#btnNuevoProv').classList.toggle('oculto', !editaProv());
  const { data, error } = await pedirTodo(() => sb.from('proveedores').select('id,nombre,cuit,contacto,activo'),
    { por: 'id', orden: ordenarPor('nombre', 'id') });
  ERROR_PROVS = error ? error.message : '';
  PROVS = error ? [] : (data || []);
  LEIDA = true;
  pintarLista();
  if (ABIERTO != null) leerFicha(ABIERTO);
}

function pintarLista(){
  if (ERROR_PROVS){
    $('#tblProvs').innerHTML = `<tr><td colspan="4" class="vacio">No se pudieron leer los proveedores (${esc(ERROR_PROVS)}). No quiere decir que no haya.</td></tr>`;
    return;
  }
  if (!LEIDA){ $('#tblProvs').innerHTML = '<tr><td colspan="4" class="vacio">Leyendo los proveedores…</td></tr>'; return; }
  const q = ($('#buscaProv').value || '').toLowerCase().trim();
  const f = PROVS.filter(p => !q || [p.nombre, p.cuit, p.contacto].some(v => (v || '').toLowerCase().includes(q)));
  $('#tblProvs').innerHTML = f.map(p => `
    <tr><td><a href="#" data-fichaprov="${p.id}"><b>${esc(p.nombre)}</b></a></td>
        <td class="mono">${esc(p.cuit || '—')}</td>
        <td>${esc(p.contacto || '—')}</td>
        <td>${p.activo ? '<span class="chip c-ok">activo</span>' : '<span class="chip c-warn">inactivo</span>'}</td></tr>`).join('')
    || `<tr><td colspan="4" class="vacio">${PROVS.length ? 'Ningún proveedor coincide con la búsqueda' : 'Todavía no hay proveedores cargados'}</td></tr>`;
}
$('#buscaProv').oninput = pintarLista;
$('#tblProvs').onclick = e => {
  const a = el(e.target).closest('[data-fichaprov]');
  if (!a) return;
  e.preventDefault();
  abrirFicha(Number(a.dataset.fichaprov));
};

//  Desde la lista de órdenes (el nombre del proveedor) también se entra.
export function abrirFicha(id: number | null){
  ABIERTO = id;
  const turno = ++TURNO;
  for (const s of ['#fpvMsg', '#fpvGuardarMsg', '#fpvOrdMsg', '#fpvRemMsg', '#fpvCuentaMsg']) limpiar(s);
  $('#cardFichaProv').classList.remove('oculto');
  $('#fpvTit').textContent = id == null ? 'Nuevo proveedor' : 'Proveedor';
  $('#fpvNombre').value = ''; $('#fpvCuit').value = ''; $('#fpvContacto').value = ''; $('#fpvActivo').checked = true;
  $('#fpvActivoLbl').classList.toggle('oculto', id == null);
  $('#fpvDetalle').classList.toggle('oculto', id == null);
  for (const x of ['#fpvNombre', '#fpvCuit', '#fpvContacto', '#fpvActivo']) $(x).disabled = !editaProv();
  $('#btnFpvGuardar').classList.toggle('oculto', !editaProv());
  $('#btnFpvGuardar').textContent = id == null ? 'Dar de alta' : 'Guardar';
  $('#fpvSoloLectura').textContent = editaProv() ? '' : 'Sólo lectura: no tenés permiso para cambiar proveedores.';
  $('#cardFichaProv').scrollIntoView({ block: 'nearest' });
  if (id == null){ $('#fpvNombre').focus(); return; }
  leerFicha(id, turno);
}
$('#btnNuevoProv').onclick = () => abrirFicha(null);
$('#fpvCerrar').onclick = () => { ABIERTO = null; TURNO++; $('#cardFichaProv').classList.add('oculto'); };

async function leerFicha(id: number, turno = ++TURNO){
  const p = PROVS.find(x => Number(x.id) === id);
  if (!p){
    aviso('#fpvMsg', ERROR_PROVS ? 'bad' : 'warn', ERROR_PROVS
      ? 'No se pudieron leer los proveedores: la ficha no se puede mostrar.'
      : 'Ese proveedor ya no está en la lista.');
    return;
  }
  $('#fpvTit').textContent = p.nombre;
  $('#fpvNombre').value = p.nombre || ''; $('#fpvCuit').value = p.cuit || '';
  $('#fpvContacto').value = p.contacto || ''; $('#fpvActivo').checked = !!p.activo;
  leerOrdenes(id, turno); leerRemitos(id, turno); leerCuenta(id, turno);
}

async function leerOrdenes(id: number, turno: number){
  if (!puede('compra', 'ver')){
    $('#fpvOrdenes').innerHTML = '<p class="hint">No tenés permiso para ver las órdenes de compra.</p>'; return;
  }
  $('#fpvOrdenes').innerHTML = '<p class="vacio">Leyendo sus órdenes…</p>';
  const { data, error } = await pedir(sb.from('v_ordenes_compra')
    .select('orden_id,numero,estado,avance,pedido,recibido,pendiente,creado_en')
    .eq('proveedor_id', id).order('orden_id', { ascending: false }).limit(TOPE));
  if (turno !== TURNO) return;
  if (error){ $('#fpvOrdenes').innerHTML = `<p class="vacio">No se pudieron leer sus órdenes (${esc(error.message)}). No quiere decir que no tenga.</p>`; return; }
  const os = (data || []) as any[];
  $('#fpvOrdenes').innerHTML = os.length
    ? `<div class="tw"><table><thead><tr><th>Orden</th><th>Fecha</th><th>Estado</th><th>Avance</th>
         <th class="num">Pedido</th><th class="num">Recibido</th><th class="num">Falta</th></tr></thead><tbody>${
        os.map(o => `<tr><td class="mono">${esc(o.numero)}</td><td>${esc(fecha(o.creado_en))}</td>
          <td>${esc(o.estado)}</td><td>${esc(o.avance || '—')}</td><td class="num">${num(o.pedido)}</td>
          <td class="num">${num(o.recibido)}</td><td class="num">${o.pendiente ? `<b>${num(o.pendiente)}</b>` : '—'}</td></tr>`).join('')
      }</tbody></table></div>${os.length === TOPE ? `<p class="hint">Las ${TOPE} más nuevas; hay más.</p>` : ''}`
    : '<p class="vacio">Todavía no tiene órdenes de compra.</p>';
}

async function leerRemitos(id: number, turno: number){
  if (!puede('recepcion', 'ver')){
    $('#fpvRemitos').innerHTML = '<p class="hint">No tenés permiso para ver los remitos.</p>'; return;
  }
  $('#fpvRemitos').innerHTML = '<p class="vacio">Leyendo sus remitos…</p>';
  const { data, error } = await pedir(sb.from('v_recepciones')
    .select('recepcion_id,remito,ocurrido_en,recibio,lineas,unidades,ordenes')
    .eq('proveedor_id', id).order('ocurrido_en', { ascending: false }).limit(TOPE));
  if (turno !== TURNO) return;
  if (error){ $('#fpvRemitos').innerHTML = `<p class="vacio">No se pudieron leer sus remitos (${esc(error.message)}). No quiere decir que no tenga.</p>`; return; }
  const rs = (data || []) as any[];
  $('#fpvRemitos').innerHTML = rs.length
    ? `<div class="tw"><table><thead><tr><th>Cuándo</th><th>Remito</th><th>Recibió</th>
         <th class="num">Líneas</th><th class="num">Unidades</th></tr></thead><tbody>${
        rs.map(r => `<tr><td>${esc(fecha(r.ocurrido_en))}</td><td class="mono">${esc(r.remito || '—')}</td>
          <td>${esc(r.recibio || '—')}</td><td class="num">${num(r.lineas)}</td><td class="num">${num(r.unidades)}</td></tr>`).join('')
      }</tbody></table></div>${rs.length === TOPE ? `<p class="hint">Los ${TOPE} más nuevos; hay más.</p>` : ''}`
    : '<p class="vacio">Todavía no tiene remitos.</p>';
}

async function leerCuenta(id: number, turno: number){
  if (!puede('proveedor', 'ver_cuenta')){
    $('#fpvCuenta').innerHTML = '<p class="hint">La cuenta del proveedor la ve quien tiene ese permiso (el dueño).</p>'; return;
  }
  $('#fpvCuenta').innerHTML = '<p class="vacio">Leyendo su cuenta…</p>';
  const { data, error } = await pedir(sb.from('v_proveedores_cc')
    .select('saldo,ultimo_movimiento,movimientos,recepciones_sin_costo').eq('proveedor_id', id));
  if (turno !== TURNO) return;
  if (error){ $('#fpvCuenta').innerHTML = `<p class="vacio">No se pudo leer su cuenta (${esc(error.message)}).</p>`; return; }
  const c = (data || [])[0];
  const saldo = Number(c?.saldo || 0);
  $('#fpvCuenta').innerHTML = `<p>${!c ? 'Sin movimientos.'
      : saldo > 0.005 ? `Se le debe <b>${num(saldo)}</b>.`
      : saldo < -0.005 ? `Tenemos <b>${num(-saldo)}</b> a favor.` : 'La cuenta está en cero.'}${
      c && Number(c.recepciones_sin_costo || 0) ? ` <span class="hint">Ojo: ${num(c.recepciones_sin_costo)} línea(s) de remito sin costo todavía no generaron deuda.</span>` : ''}</p>
    <div class="fila-acc" style="justify-content:flex-start"><button class="b b-sec" type="button" id="fpvIrCuenta">Ver su cuenta</button></div>`;
  $('#fpvIrCuenta').onclick = () => irACuentaDe(id);
}

$('#formFichaProv').onsubmit = async (e: Event) => {
  e.preventDefault();
  limpiar('#fpvGuardarMsg');
  if (!editaProv()) return;
  const alta = ABIERTO == null;
  const p = alta ? null : PROVS.find(x => Number(x.id) === ABIERTO);
  if (!alta && !p){ aviso('#fpvGuardarMsg', 'bad', 'Ese proveedor ya no está en la lista: cerrá la ficha y volvé a entrar.'); return; }
  const d: Record<string, unknown> = {};
  const val = (s: string) => ($(s).value || '').trim();
  if (alta || val('#fpvNombre') !== (p.nombre || '')) d.nombre = val('#fpvNombre');
  if (alta || val('#fpvCuit') !== (p.cuit || '')) d.cuit = val('#fpvCuit');
  if (alta || val('#fpvContacto') !== (p.contacto || '')) d.contacto = val('#fpvContacto');
  if (!alta && $('#fpvActivo').checked !== !!p.activo) d.activo = $('#fpvActivo').checked;
  if (!alta && !Object.keys(d).length){ aviso('#fpvGuardarMsg', 'ok', 'No cambiaste nada.'); return; }
  if (alta && !d.nombre){ aviso('#fpvGuardarMsg', 'bad', 'Escribí el nombre del proveedor.'); return; }
  const b = $('#btnFpvGuardar'); b.disabled = true;
  const { data, error } = await rpc('guardar_proveedor', { p_proveedor_id: ABIERTO as any, p_datos: d as any });
  if (noContesto(error)){
    aviso('#fpvGuardarMsg', 'warn', error.message + ' No se sabe si quedó guardado: fijate en la lista antes de repetirlo.');
    cargarProveedoresFicha();
    return;
  }
  b.disabled = false;
  if (error){ aviso('#fpvGuardarMsg', 'bad', error.message); return; }
  if (alta) ABIERTO = Number(data.id);
  cargarCatalogos();
  AL_CAMBIAR?.();
  await cargarProveedoresFicha();
  if (alta) abrirFicha(ABIERTO);
  aviso('#fpvGuardarMsg', 'ok', data.mensaje);
};
